<template>
  <div class="main-content">

    <!-- Section: home -->
    <section id="home" class="divider">
      <div class="container-fluid p-0">
        
        <!-- Slider Revolution Start -->
        <div id="home-slider" class="rev_slider_wrapper">
          <div class="rev_slider" data-version="5.0">
            <ul>

              <!-- SLIDE 1 -->
              <li data-index="rs-7" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut" data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0"  data-fstransition="fade" data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="Movement Flow" data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah31.jpg"  alt=""  data-bgposition="35% 55%" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-1"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['-110'']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">BENVENUTA NEL MONDO DI MOVEMENT FLOW.
                </div>

                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-1"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['-60'']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Ti insegnerò a prenderti cura di te a 360°
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['-10'']"
                  data-fontsize="['22', '18']"
                  data-lineheight="['50']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Insieme renderemo divertente e stimolante
                </div>

              <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['30']"
                  data-fontsize="['22', '18']"
                  data-lineheight="['50']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">ciò che prima risultava difficile e noioso.
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-5"
                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['100']"
                  data-fontsize="['90','64','54','24']"
                  data-lineheight="['95']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><a class="btn btn-theme-colored" style="font-size:18px" href="/category?Key=MovementFlow">Acquista</a>
                </div>
              </li>
              
              <!-- SLIDE 2 -->
              <li data-index="rs-1" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut" data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0"  data-fstransition="fade" data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="Movimento" data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah89.jpg"  alt=""  data-bgposition="center 70%" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-1"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['-60'']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Il mio mondo ti aiuterà a trovare
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['-10']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">L'equilibrio, la consapevolezza e la forza
                </div>

                 <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['40']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">Necessari nella vita di tutti i giorni, attravero il
                </div>

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-3"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['100']"
                  data-fontsize="['90','64','54','24']"
                  data-lineheight="['95']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><span class="text-theme-colored">MOVIMENTO</span>
                </div>
              </li>

              <!-- SLIDE 3 -->
              <li data-index="rs-2" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut" data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0"  data-fstransition="fade" data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="Healty e happy!" data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah10.jpg"  alt=""  data-bgposition="center 25%" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

                <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-1-layer-1"

                  data-x="['left']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['-110'']"
                  data-fontsize="['90','64','54','24']"
                  data-lineheight="['95']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><span class="text-theme-colored">SANO E IN ARMONIA!</span>
                </div>

                <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['left']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['0']"
                  data-fontsize="['30', '22']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">EQUILIBRIO E MODERAZIONE SONO LA CHIAVE DI TUTTO.
                </div>

                 <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['left']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['40']"
                  data-fontsize="['30', '22']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">INSIEME COSTRUIREMO UN RAPPORTO SANO, EQUILIBRATO CON IL CIBO.
                </div>

                <!-- LAYER NR. 2 -->
                <!-- <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['left']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['80']"
                  data-fontsize="['30', '22']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">PRENDITI CURA DI TE E GODITI IL VIAGGIO!
                </div> -->

              </li>

              <!-- SLIDE 4 -->
              <li data-index="rs-3" data-transition="zoomout" data-slotamount="default" data-easein="Power4.easeInOut" data-easeout="Power4.easeInOut" data-masterspeed="1500" data-rotate="0" data-fstransition="fade" data-fsmasterspeed="1500" data-fsslotamount="7" data-saveperformance="off" data-title="WORKOUT" data-description="">
                <!-- MAIN IMAGE -->
                <img src="images/202208/Sarah113.jpg"  alt=""  data-bgposition="center 30%" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-bgparallax="6" data-no-retina>
                <!-- LAYERS -->

      <!-- LAYER NR. 1 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-1"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['0']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1000" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">QUI TROVERAI DIVERSI PERCORSI CHE TI AIUTERANNO
                </div>

                 <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['40']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">A REALIZZARE I TUOI OBIETTIVI
                </div>

                
                 <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['80']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">MA TUTTO DIPENDE DALLA TUA REALE MOTIVAZIONE
                </div>

                 <!-- LAYER NR. 2 -->
                <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-2"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['120']"
                  data-fontsize="['36', '24']"
                  data-lineheight="['75']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1200" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:500;">E DAL TUO IMPEGNO.
                </div>

                <!-- LAYER NR. 1 -->
                <!-- <div class="tp-caption tp-resizeme text-uppercase font-raleway text-center text-white" 
                  id="rs-3-layer-3"

                  data-x="['right']"
                  data-hoffset="['30']"
                  data-y="['middle']"
                  data-voffset="['190']"
                  data-fontsize="['90','64','54','24']"
                  data-lineheight="['95']"

                  data-width="none"
                  data-height="none"
                  data-whitespace="nowrap"
                  data-transform_idle="o:1;s:500"
                  data-transform_in="y:100;scaleX:1;scaleY:1;opacity:0;"
                  data-transform_out="x:left(R);s:1000;e:Power3.easeIn;s:1000;e:Power3.easeIn;"
                  data-mask_in="x:0px;y:0px;s:inherit;e:inherit;"
                  data-mask_out="x:inherit;y:inherit;s:inherit;e:inherit;"
                  data-start="1500" 
                  data-splitin="none" 
                  data-splitout="none" 
                  data-responsive_offset="on"
                  style="z-index: 5; white-space: nowrap; font-weight:700;"><span class="text-theme-colored">INIZIAMO</span>
                </div> -->
              </li>


            </ul>
          </div>
        </div>
        <!-- Slider Revolution Ends -->
      </div>
    </section>

    <section id="trial" class="divider parallax  layer-overlay"  data-parallax-ratio="0.7" v-if="!loggedIn">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-30 font-brooklyn-light">
                  ISCRIVITI E AVRAI ACCESSO ALL'AREA PERSONALE CON UN <span class="text-theme-colored">PROGRAMMA GRATUITO</span> PER 7 GIORNI
                </h3>
                <a class="btn btn-theme-colored" href="/subscribe">ISCRIVITI</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Categories -->
    <section id="categories">
      <div class="container" v-if="results != null && results.length > 0">    
        
     <div class="messageHomePayPal"
            data-pp-message
            data-pp-style-layout="flex"
            data-pp-style-ratio="20x1"
            data-pp-style-color="black">
        </div>
          <div class="row mtli-row-clearfix p-20" id="dashboardPrograms">            
            <div class="col-sm-4 pb-20" v-for="category in results" :key="category.id">
              <a :href="'/category?Key=' + category.UrlKey" class="class-item box-hover-effect effect1 mb-md-30 bg-lighter category-item">
                  <div class="thumb mb-20">
                    <img :alt="category.Image[0].alternativeText" :src="baseUrl + category.Image[0].url" class="img-fullwidth"> 
                  </div>
                  <div class="content text-left flip p-25 pt-0">
                    <h4 class="text-uppercase font-weight-800 line-bottom">{{category.Title}}</h4>
                    <p>{{category.ShortDescription}}</p>
                    <a class="btn-read-more btn-sm">Scopri</a>
                  </div>
                </a>
            </div>
          </div>
        </div>
    </section>

    <!-- Section: Categories -->
    <section id="callToAction" class="divider parallax layer-overlay"  data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10" style="text-align:center">                
                <video controls autoplay style="width:100%;">
                  <source src="/strapi/uploads/Sarah_insta_2_converted_medium_d0d3680d4e.mp4" type="video/mp4">                  
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: callToAction  -->
    <section id="callToAction" class="divider parallax  layer-overlay"  data-parallax-ratio="0.7">
      <div class="container pb-50 pt-50">
        <div class="section-content text-center">
          <div class="row">
            <div class="col-md-12">
              <div class="call-to-action pt-10">
                <h3 class="text-dark mb-30 font-brooklyn-light">
                  Per chi lo desidera è possibile accedere ad un <span class="text-theme-colored">programma</span> specifico <span class="text-theme-colored">personalizzato</span>,<br />
                  strettamente cucito sui propri obiettivi ed esigenze.
                </h3>
                <a class="btn btn-theme-colored" href="/contactme">Contatta</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Gallery -->
    <section id="gallery"  class="divider parallax layer-overlay" v-if="gallery && gallery.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- Portfolio Gallery Grid -->
            <div class="gallery-isotope grid-3 masonry gutter-small clearfix" data-lightbox="gallery">

              <!-- Portfolio Item Start -->
              <div class="gallery-item" v-for="galleryImg in gallery" :key="galleryImg.id">
                <a :href="baseUrl + galleryImg.Image.url" data-lightbox="gallery-item" :title="galleryImg.Title"><img :src="baseUrl + galleryImg.Image.url" alt=""></a>
              </div>
              <!-- Portfolio Item End -->
            </div>
            <!-- End Portfolio Gallery Grid -->
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<style scoped>
a.class-item {
  display: block;
}

.messageHomePayPal {
  margin-left: 15px;
  margin-right: 15px;
}

#categories{
  background-color: #e0e0e0;
}

#callToAction h3 {
  font-size: 22px;
}

#callToAction {
  background-color: #f5f5f5;
}

@media only screen and (max-width: 768px) {
  #callToAction h3 {
    font-size: 18px;
  }
}
</style>

<script>
import axios from "axios";
import { THEMEMASCOT } from "../../public/js/custom.js";

export default {
  name: "Home",
  data() {
    return {
      results: [],
      baseUrl: process.env.VUE_APP_API_URL,
      gallery: [],
      loggedIn: !(localStorage.getItem('token') == undefined || localStorage.getItem('token') == null || localStorage.getItem('token') == "")
    };
  },
  mounted() {
    axios.get(process.env.VUE_APP_API_URL + "/categories?IsVisible=true").then(response => {
      this.results = response.data;
      THEMEMASCOT.slider.init();
    });

    axios.get(process.env.VUE_APP_API_URL + "/home-galleries").then(response => {
        this.gallery = response.data;
        console.log("Gallery:" , this.gallery);
        THEMEMASCOT.widget.init();
    });
  }
};
</script>
